import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { useNavigate } from 'react-router-dom'
import { Column } from 'primereact/column'
import { Flex, Text, Button, Spinner } from '../../../Components'
import { useCQuery } from '../../../Services/QueryCache'
import { columnProps } from '../../Reports/Functions'

export function SocietiesList () {
  const { data: users = [], isSuccess } = useCQuery(['users'])
  const [usersTable, setUsersTable] = useState([])
  const navigate = useNavigate([])

  useEffect(() => {
    isSuccess && setUsersTable([...new Map(users.map((item) => [item.codSociety, item])).values()])
  }, [users, isSuccess])

  const BtnActions = ({ codSociety }) => {
    return (
      <Flex width={160} row>
        <Button round tooltip='Modifica' icon='edit' onClick={() => navigate('/tipiServizi/' + codSociety + '/list')} />
      </Flex>
    )
  }

  if (!isSuccess) return <Spinner />
  return (
    <Flex fw fh js>
      <Text value='Lista Società' size={20} bold />
      <DataTable
        style={{ width: '100%' }} filterDisplay='row' sortField='createdAt' sortOrder={-1} className='TableSignatures'
        value={usersTable} emptyMessage='Nessun utente trovato' responsiveLayout='scroll' paginator rows={10}
      >
        <Column field='codSociety' {...columnProps('Codice Società')} />
        <Column style={{ border: 'none', width: 140, height: 15, textAlign: 'center' }} body={(props) => <BtnActions {...props} />} />
      </DataTable>
    </Flex>
  )
}
